import React from "react";
import PropTypes from "prop-types";
import R from "ramda";
import { Grid, Button, Container, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";

import Pill from "components/Pill";
import Placeholder from "components/Placeholder";
import { appRoutes } from "routes";

import useStyles from "./useStyles";

const FeaturedCategories = ({ items, loading }) => {
  const classes = useStyles();

  const renderTitle = () => {
    if (loading)
      return (
        <Typography variant="h2" className={classes.title}>
          <Placeholder variant="text" />
        </Typography>
      );
    return (
      <Typography variant="h2" className={classes.title}>
        Featured categories
      </Typography>
    );
  };

  const renderContent = () => {
    if (loading)
      return R.range(0, 4).map((index) => (
        <Grid key={`FeaturedCategories-placeholder-${index}`} item xs={6} sm={3}>
          <Pill loading />
        </Grid>
      ));

    return items.map((item) => (
      <Grid key={`pill-${item.id}`} item xs={6} sm={3}>
        <Pill item={item} />
      </Grid>
    ));
  };

  return (
    <div className={classes.root}>
      <Container>
        {renderTitle()}
        <Grid container spacing={2} className={classes.grid}>
          {renderContent()}
        </Grid>
        <Grid container direction="row" justify="center" alignItems="center">
          <Grid item>
            <Button component={Link} variant="outlined" color="primary" to={appRoutes.categoriesPath()}>
              View more
            </Button>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

FeaturedCategories.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      type: PropTypes.string,
      attributes: PropTypes.shape({}),
    }).isRequired,
  ),
  loading: PropTypes.bool,
};

export default FeaturedCategories;
